import { render } from "./client_kyc.vue?vue&type=template&id=76bcf276"
import script from "./client_kyc.vue?vue&type=script&lang=js"
export * from "./client_kyc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__